<template>

    <table ref="table" @mouseup="onmouseup" @mousemove="onmousemove">
        <thead>
        <draggable :modelValue="cols" @update:modelValue="updateCols" tag="tr"
                   :item-key="name => name">
            <template #header>
                <th></th>
            </template>
            <template #item="{ element:h, index:i}">
                <th
                    :class="[h.class, !h.visible ? 'hidden': '']"
                    class="p-2 relative select-none"
                    :style="getStyleWidth(h)"
                >
                    <div class="flex whitespace-nowrap">
                        <span class="flex flex-col text-sm">
                            {{ h.name }}
                        <span class="text-[8px]">{{ h.prop }}</span>
                        </span>
                        <span v-show="h.orderable" class="ml-2" @click.exact="reorder(h,i)">
                            <i class="fa fa-chevron-up transition-transform origin-center cursor-pointer"
                               :class="icon(i)"></i>
                        </span>
                    </div>
                    <span @mousedown.stop.prevent="onmousedown($event, h)" v-show="h.resizable"
                          class="z-10 absolute top-0 bottom-0 w-1.5 right-0 translate-x-1/2 bg-next-gray-md-darker rounded cursor-col-resize"></span>
                </th>
            </template>
            <template #footer>
                <th class="px-4"></th>
            </template>
        </draggable>
        </thead>
        <draggable
            tag="tbody"
            :modelValue="rows"
            @update:modelValue="updateRows"
            item-key="uuid"
            draggable=".main_row"
            handle=".drag-handle"
        >
            <template #item="{element:r, index:i}">
                <tr :class="{'main_row': !(r._nuvola || r._alternativa)}">
                    <td>
                        <slot :name="`td_${i}_preactions`" v-bind="{row: r}">
                        </slot>
                    </td>
                    <td v-for="(c, j) in cols" :key="`${i}_${j}`" class="border-2 relative p-0"
                        :class="[c.td_class, !c.visible ? 'hidden': '', r._nuvola||r.nuvole?.length ? nuvola_td_class: r._alternativa||r.alternative?.length ? alternativa_td_class: isOpzionale(r)? opzionale_td_class: 'border-next-light-gray' ]">
                        <slot :name="`td_${i}_${c.prop}`" v-bind="{row: r, cell: c}">
                            {{ r[c.prop] }}
                        </slot>
                    </td>
                    <td :class="$attrs.actionClass">
                        <slot :name="`td_${i}_actions`" v-bind="{row: r}">
                        </slot>
                    </td>
                </tr>
            </template>
        </draggable>
    </table>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {TableColDef, TableOrder, TableRowDef} from "@/types";
import draggable from "vuedraggable";
import {mapGetters} from "vuex";

@Options({
    name: 'NextSottoProgettoTable',
    props: {
        cols: Array,
        rows: Array,
        nuvola_td_class: {
            type: String,
            default: 'border-amber-300'
        },
        alternativa_td_class: {
            type: String,
            default: 'border-green-300'
        },
        opzionale_td_class: {
            type: String,
            default: 'border-red-300'
        },
    },
    components: {
        draggable
    },
    computed: {
        ...mapGetters('sprjDataManager', [
            'isDescrizione',
            'isOpzionale'
        ]),
    },
})
export default class NextSottoProgettoTable extends Vue {
    cols!: TableColDef[]
    rows!: TableRowDef[]

    dragging?: MouseEvent;

    resizing_initial_width = 0
    resizing_element: HTMLElement | null = null
    resizing_event: MouseEvent | null = null
    resizing_col_prop: string | null = null
    resizing_final: number | null = null


    icon(i: number) {
        const o = this.cols[i].order || TableOrder.NONE
        switch (o) {
            case TableOrder.NONE:
                return 'rotate-90';
            case TableOrder.ASC:
                return '';
            case TableOrder.DESC:
                return 'rotate-180'
        }
    }

    onmousedown(e: MouseEvent, h: TableColDef) {
        //@ts-ignore
        this.resizing_initial_width = e.target.parentNode.offsetWidth
        // @ts-ignore
        this.resizing_element = e.target.parentNode
        this.resizing_event = e
        this.resizing_col_prop = h.prop
    }

    onmouseup(e: MouseEvent) {
        if (this.isResizing) {
            e.preventDefault()
            e.stopPropagation()
            //@ts-ignore
            const diff = e.clientX - this.resizing_event.clientX
            if (this.resizing_element && this.resizing_col_prop) {
                this.updateColWidth(this.resizing_initial_width + diff)
            }
            this.resizing_event = null
            this.resizing_element = null
            this.resizing_initial_width = 0
            this.resizing_final = null
        }
    }

    onmousemove(e: MouseEvent) {
        if (this.isResizing) {
            e.preventDefault()
            e.stopPropagation()
            //@ts-ignore
            const diff = e.clientX - this.resizing_event.clientX
            if (this.resizing_element && this.resizing_col_prop) {
                this.updateColWidth(this.resizing_initial_width + diff, false)
            }
        }
    }

    get isResizing() {
        return this.resizing_event != null
    }

    reorder(h: any, i: number) {
        this.$emit('order-update', h.prop)
    }

    updateColWidth(width: number, emit_sync?: boolean) {
        const resizing_col_def = this.cols.find((e) => e.prop == this.resizing_col_prop)
        if (resizing_col_def) {
            resizing_col_def.width = width
            this.updateCols(this.cols, emit_sync)
        }
    }

    getStyleWidth(h: TableColDef) {
        if (h.width) {
            return {
                'minWidth': `${h.width}px`
            }
        }
    }

    updateCols(cols: any[], emit_sync = true) {
        if (emit_sync) {
            this.$emit('update:cols', cols)
        }
    }


    updateRows(rows: any[], emit_sync = true) {
        if (emit_sync) {
            this.$emit('update:rows', rows)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
